import React from 'react';
import PropTypes from 'prop-types';
import NotificationMessage from '../common/NotificationMessage.js';
import { NotificationCenter } from '../utils/types';
import { fetchAuthenticatedStarfishJSON } from '../utils/request';

export default class BatchActionNotification extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      batchCount: 0,
      display: props.display
    };

    this.notificationRef = React.createRef();
    this.updateCount = this.updateCount.bind(this);
    this.handleBatchSent = this.handleBatchSent.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount() {
    this.props.notificationCenter.addListener('batchactioncount', this.handleBatchSent);
    this.updateCount();
  }

  componentWillUnmount() {
    this.props.notificationCenter.removeListener('batchactioncount', this.handleBatchSent);
  }

  updateCount() {
    const batchCountURL = `../instructor/getBatchedActionsCount.html`;

    fetchAuthenticatedStarfishJSON(batchCountURL, 'batchedActionsCount', {
      method: 'GET'
    })
      .then(batchCount => {
        if(batchCount > 0) {
          this.setState({ batchCount })
        } else {
          this.handleClose()
        }
      });
  }

  handleBatchSent() {
    this.updateCount();
    this.notificationRef.current.setState({ visibility: true });
    this.setState({ display: true });
  }

  handleClose() {
    this.notificationRef.current.setState({ visibility: false });
    this.setState({ display: false });
  }

  render() {
    return (
      <NotificationMessage
        ref={this.notificationRef}
        message={`You have ${this.state.batchCount} item(s) in your Batch Sent Queue.`}
        display={this.props.display}
        onClose={this.handleClose}
      />
    );
  }
}

BatchActionNotification.propTypes = {
  notificationCenter: NotificationCenter.isRequired,
  display: PropTypes.bool.isRequired
};
